export * from './setupFLKWindow.component';
